module.exports = __webpack_public_path__ + "img/6-en.ec7a38c8.png";